import cn from "classnames";
import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import { upperFirst } from "lodash";
import s from "./Input.module.scss";
import { Option } from "components/UI/form/Select";
import React from "react";

export type InputProps = {
  label?: string;
  placeholder?: string;
  name?: string;
  type?: string;
  options?: Option[];
  initialValue?: string | number;
  defaultValue?: string | number;
  min?: number;
  max?: number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  error?: boolean | ReactNode;
  disabled?: boolean;
  maxLength?: number;
  className?: string;
} & InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      placeholder,
      name,
      type = "text",
      initialValue,
      onChange,
      defaultValue,
      disabled = false,
      error = false,
      onKeyDown,
      onKeyUp,
      maxLength,
      className = "",
      onBlur,
    },
    ref
  ) => {
    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(event);
    };
    return (
      <label
        className={cn(
          s.input,
          s[`Type${upperFirst(type)}`],
          {
            [s.inputError]: !!error,
          },
          className
        )}
      >
        {label && <span className={cn(s.inputLabel, "inputLabel")}>{label}</span>}
        <input
          ref={ref}
          type={type}
          placeholder={placeholder}
          name={name}
          defaultValue={defaultValue}
          className={s.inputEl}
          value={initialValue}
          onChange={onChangeHandler}
          disabled={disabled}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          maxLength={maxLength}
          onBlur={onBlur}
        />
        {error && typeof error !== "boolean" && <span className={s.inputErrorMsg}>{error}</span>}
      </label>
    );
  }
);

Input.displayName = "Input";
